// import React from "react";
// import { useNavigate } from "react-router-dom";

// const RequireNoAuth = ({ children }) => {
//   const navigate = useNavigate();
//   const token = localStorage.getItem("token");


//   React.useEffect(() => {
//     if (token) {
//       navigate("/");
//     }
//   }, [token, navigate]);

//   return !token ? children : null;
// };

// export default RequireNoAuth;

import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const RequireNoAuth = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token");


  React.useEffect(() => {
    if (token && location.pathname === "/login") {
      navigate("/");
    }
  }, [token, navigate, location.pathname]);

  return !token ? children : null;
};

export default RequireNoAuth;
